import "./CapsuleCardHorizontal.css";

const CapsuleCardHorizontal = ({
  data,
  product,
  variant,
  handleQuantityChange,
  quantity,
  totalItems,
}) => {
  return (
    <div key={product.productPlatformId} className="capsule-card capsule-card-horizontal">
      <div className="capsule-card-info-wrapper">
        <img src={product.productImageSrc} alt={product.productTitle} />
        <div className="capsule-card-info-wrapper-inner">
          <div className="capsule-card-info-titles">
            <h3 className="capsule-card-product-title">{product.productTitle}</h3>
            <span className="middle-dot">·</span>
            <span className="capsule-card-variant-title">{variant.productVariantTitle}</span>
          </div>
          <span className="capsule-card-price">
            {data.DynamicBox.currencyCode === "USD" ? "$" : ""}
            {variant.price}
          </span>
        </div>
      </div>

      <div className="quantity-selector">
        <button
          className="minus"
          onClick={() => handleQuantityChange(product, variant, Math.max(quantity - 1, 0))}
          disabled={quantity === 0}>
          -
        </button>
        <span className="quantity">{quantity}</span>
        <button
          className="plus"
          onClick={() => handleQuantityChange(product, variant, quantity + 1)}
          disabled={totalItems >= 8 && quantity === 0}>
          +
        </button>
      </div>
    </div>
  );
};

export default CapsuleCardHorizontal;
